var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAudioOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.2,0c0.2,0.1,0.5,0.1,0.7,0.2c1.5,0.5,2.4,1.8,2.4,3.3c0,2.1,0,4.3,0,6.4c0,1.6-0.9,2.8-2.4,3.3 c-0.4,0.1-0.7,0.1-1.1,0.2c-0.1,0-0.1,0-0.2,0c0,1.1,0,2.1,0,3.2c1.2,0,2.5,0,3.7,0c0,0.5,0,0.9,0,1.4c-2.9,0-5.8,0-8.8,0 c0-0.5,0-0.9,0-1.4c1.2,0,2.4,0,3.6,0c0-1.1,0-2.1,0-3.1c-0.3,0-0.6,0-0.8-0.1c-1.4-0.2-2.6-1.4-2.8-2.9c0-0.2,0-0.4,0-0.6 c0-2.1,0-4.2,0-6.3c0-1.5,0.7-2.6,2.1-3.3C7,0.2,7.3,0.1,7.6,0c0.1,0,0.1,0,0.2,0C8.6,0,9.4,0,10.2,0z M8.3,10.2c-0.8,0-1.5,0-2.3,0 c0.1,1,1,1.8,2,1.8c0.6,0,1.2,0,1.8,0c0.5,0,1-0.1,1.4-0.5c0.4-0.3,0.7-0.8,0.7-1.4c-0.8,0-1.5,0-2.3,0c0-0.5,0-0.9,0-1.4 c0.8,0,1.5,0,2.3,0c0-0.5,0-0.9,0-1.4c-0.8,0-1.5,0-2.3,0c0-0.5,0-0.9,0-1.4c0.8,0,1.5,0,2.3,0c0-0.5,0-0.9,0-1.4 c-0.8,0-1.5,0-2.3,0c0-0.5,0-0.9,0-1.4c0.4,0,0.7,0,1.1,0c0.4,0,0.7,0,1.1,0c-0.1-1-1-1.8-2-1.8c-0.6,0-1.3,0-1.9,0 c-1,0-1.9,0.8-2,1.8c0.7,0,1.5,0,2.2,0c0,0.5,0,0.9,0,1.4c-0.8,0-1.5,0-2.3,0C6,5.1,6,5.5,6,6c0.8,0,1.5,0,2.3,0c0,0.5,0,0.9,0,1.4 c-0.8,0-1.5,0-2.3,0c0,0.5,0,0.9,0,1.4c0.8,0,1.5,0,2.3,0C8.3,9.3,8.3,9.7,8.3,10.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioOn);
export default __webpack_public_path__ + "static/media/audioOn.2eff0436205d599463180d02a3133005.svg";
export { ForwardRef as ReactComponent };